import React from 'react';
import { styled } from 'styled-components';

import { ReactComponent as EmptyImage } from 'src/assets/empty.svg';

export const ContentEmpty = ({ title }: { title: string }) => (
  <ContentEmptyBox>
    <EmptyImage style={{ width: 200, height: 200 }} />
    <div className="title">{title}</div>
  </ContentEmptyBox>
);

const ContentEmptyBox = styled.div`
  width: 200px;
  height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .title {
    font-weight: 500;
  }
`;
